import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { submitViewing } from "@/lib/docstate";

export const ViewingForm = ({ listing }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", preferred_date: "", message: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please add your name and phone number");
      return;
    }
    setSending(true);
    try {
      await submitViewing({ ...form, listing_id: listing?.id || "" });
      setDone(true);
      toast.success("Request sent — an agent will contact you shortly");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  if (done)
    return (
      <div className="ds-card p-6 text-center" data-testid="viewing-request-success">
        <p className="ds-display text-xl text-[#F3E5AB]">Thank you</p>
        <p className="mt-2 text-sm text-[#C9BBB2]">Your viewing request for {listing?.reference} has been received. Our agent will reach out shortly.</p>
      </div>
    );

  return (
    <form onSubmit={submit} className="ds-card p-5" data-testid="viewing-request-form">
      <p className="ds-display text-lg font-semibold text-white">Request a Viewing</p>
      <p className="mt-1 text-xs text-[#9D8D83]">Book a private tour of this property.</p>
      <div className="mt-4 space-y-3">
        <input value={form.name} onChange={set("name")} placeholder="Full name" data-testid="viewing-name" className="ds-input" />
        <input value={form.phone} onChange={set("phone")} placeholder="Phone (e.g. +9715...)" data-testid="viewing-phone" className="ds-input" />
        <input value={form.email} onChange={set("email")} placeholder="Email (optional)" data-testid="viewing-email" className="ds-input" />
        <input type="date" value={form.preferred_date} onChange={set("preferred_date")} data-testid="viewing-date" className="ds-input" />
        <textarea value={form.message} onChange={set("message")} rows={3} placeholder="Message (optional)" data-testid="viewing-message" className="ds-input resize-none" />
        <button type="submit" disabled={sending} data-testid="viewing-request-form-submit" className="ds-gold-btn w-full px-6 py-3 text-sm disabled:opacity-60">
          {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : null}{sending ? "Sending..." : "Request Viewing"}
        </button>
      </div>
    </form>
  );
};
